import { ArrowDownward, ArrowForward, ArrowUpward } from '@mui/icons-material';
import { ListItemIcon, MenuItem } from '@mui/material';
import { FC } from 'react';
import { SubroutineSortType } from '@/types/subroutine';

type SubroutineSortProps = {
  onSort: (sortSubroutine: SubroutineSortType) => void;
};

const SubroutineSort: FC<SubroutineSortProps> = (props) => {
  return (
    <>
      <MenuItem onClick={() => props.onSort('down')}>
        <ListItemIcon>
          <ArrowDownward fontSize='small' />
        </ListItemIcon>
        Sort by label
      </MenuItem>
      <MenuItem onClick={() => props.onSort('up')}>
        <ListItemIcon>
          <ArrowUpward fontSize='small' />
        </ListItemIcon>
        Sort reverse
      </MenuItem>
      <MenuItem onClick={() => props.onSort('default')}>
        <ListItemIcon>
          <ArrowForward fontSize='small' />
        </ListItemIcon>
        Sort by created
      </MenuItem>
    </>
  );
};

export default SubroutineSort;
